module.exports = __webpack_public_path__ + "img/Menu-11.b2fb4915.png";